interface Props {
  text: string;
}
export const PageNameText = ({ text }: Props) => {
  return (
    <div className="mx-auto items-center pb-16">
      <h3 className="text-6xl">{text}</h3>
    </div>
  );
};
